'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var parser = new DOMParser();

var parseHtml = function parseHtml(string) {
  return parser.parseFromString('<!doctype html><body>' + string, 'text/html').body.textContent;
};

exports.default = parseHtml;